// extracted by mini-css-extract-plugin
module.exports = {"container":"_4f40aee","heading":"_1eae9e9","form":"_1274da1","date":"_a5df91d","announcement":"_8ebbf7a"};